/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkEventsMoveToInProgressResponse
 */
export interface BulkEventsMoveToInProgressResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkEventsMoveToInProgressResponse
     */
    ok: number;
    /**
     * 
     * @type {number}
     * @memberof BulkEventsMoveToInProgressResponse
     */
    failed: number;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof BulkEventsMoveToInProgressResponse
     */
    failures: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkEventsMoveToInProgressResponse
     */
    failuresTruncated: boolean;
}

/**
 * Check if a given object implements the BulkEventsMoveToInProgressResponse interface.
 */
export function instanceOfBulkEventsMoveToInProgressResponse(value: object): value is BulkEventsMoveToInProgressResponse {
    if (!('ok' in value) || value['ok'] === undefined) return false;
    if (!('failed' in value) || value['failed'] === undefined) return false;
    if (!('failures' in value) || value['failures'] === undefined) return false;
    if ((!('failuresTruncated' in (value as Record<string, any>)) && !('failures_truncated' in (value as Record<string, any>))) || ((value as Record<string, any>)['failuresTruncated'] === undefined && (value as Record<string, any>)['failures_truncated'] === undefined)) return false;
    return true;
}

export function BulkEventsMoveToInProgressResponseFromJSON(json: any): BulkEventsMoveToInProgressResponse {
    return BulkEventsMoveToInProgressResponseFromJSONTyped(json, false);
}

export function BulkEventsMoveToInProgressResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEventsMoveToInProgressResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ok': json['ok'],
        'failed': json['failed'],
        'failures': json['failures'],
        'failuresTruncated': json['failures_truncated'],
    };
}

export function BulkEventsMoveToInProgressResponseToJSON(json: any): BulkEventsMoveToInProgressResponse {
    return BulkEventsMoveToInProgressResponseToJSONTyped(json, false);
}

export function BulkEventsMoveToInProgressResponseToJSONTyped(value?: BulkEventsMoveToInProgressResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ok': value['ok'],
        'failed': value['failed'],
        'failures': value['failures'],
        'failures_truncated': value['failuresTruncated'],
    };
}

